module.exports = __webpack_public_path__ + "static/media/GreatRetailExperience.865e7360.png";